/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DetectLevel_DetectLevelInput } from '../models/DetectLevel_DetectLevelInput';
import type { DetectLevel_DetectLevelOutput } from '../models/DetectLevel_DetectLevelOutput';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DetectLevelService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Creates a DetectLevel resource.
     * Creates a DetectLevel resource.
     * @param requestBody The new DetectLevel resource
     * @returns DetectLevel_DetectLevelOutput DetectLevel resource created
     * @throws ApiError
     */
    public apiGeotilingdetectLevelPost(
        requestBody: DetectLevel_DetectLevelInput,
    ): CancelablePromise<DetectLevel_DetectLevelOutput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/geo/tiling/detect-level',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                422: `Unprocessable entity`,
            },
        });
    }
}
